import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

export const microsoftClientId = process.env.REACT_APP_CLUBHOUSE_MICROSOFT_CLIENT_ID ?? '';
export const microsoftConfigured = microsoftClientId.trim().length > 0;

const redirectUri = process.env.REACT_APP_CLUBHOUSE_MICROSOFT_REDIRECT_URI
  ?? `${window.location.origin}/auth/microsoft/callback.html`;

const microsoftConfig: Configuration = {
  auth: {
    clientId: microsoftClientId || 'unconfigured',
    authority: 'https://login.microsoftonline.com/consumers',
    redirectUri,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii && level === LogLevel.Error) console.error(message);
      },
    },
  },
};

const microsoftClient = new PublicClientApplication(microsoftConfig);
let initialization: Promise<void> | undefined;

function initialize(): Promise<void> {
  initialization ??= microsoftClient.initialize();
  return initialization;
}

export async function getMicrosoftIdToken(): Promise<string> {
  if (!microsoftConfigured) throw new Error('Microsoft personal-account sign-in is not configured.');

  await initialize();
  const result = await microsoftClient.loginPopup({
    scopes: ['openid', 'profile', 'email'],
    prompt: 'select_account',
  });
  if (!result.idToken) throw new Error('Microsoft did not return an identity token.');
  microsoftClient.setActiveAccount(result.account);
  return result.idToken;
}

export async function microsoftLogout(): Promise<void> {
  if (!microsoftConfigured) return;

  await initialize();
  const account = microsoftClient.getActiveAccount() ?? microsoftClient.getAllAccounts()[0];
  if (account) await microsoftClient.clearCache({ account });
}